import {BaseModel} from "../../base/models/base-model.model";
import {MeasurementUnit} from "../../shared/DTO/measurementUnit";
import {ServiceState} from "../../shared/DTO/serviceState";
import * as moment from "moment";

export class ServiceHistoryModel extends BaseModel {
  private _activationDate?: moment.Moment;

  private _code?: string;

  private _contractValidation?: boolean;

  private _expectedContract?: boolean;

  private _extraNotes?: string;
  private _insertDate?: moment.Moment;
  private _measurementUnit?: MeasurementUnit;
  private _notes?: string;

  private _quantity?: number;
  private _state?: ServiceState;

  private _subscription?: boolean;

  constructor(activationDate?: moment.Moment, code?: string, contractValidation?: boolean, expectedContract?: boolean, extraNotes?: string, insertDate?: moment.Moment, measurementUnit?: MeasurementUnit, notes?: string, quantity?: number, state?: ServiceState, subscription?: boolean) {
    super();
    this._activationDate = activationDate;
    this._code = code;
    this._contractValidation = contractValidation;
    this._expectedContract = expectedContract;
    this._extraNotes = extraNotes;
    this._insertDate = insertDate;
    this._measurementUnit = measurementUnit;
    this._notes = notes;
    this._quantity = quantity;
    this._state = state;
    this._subscription = subscription;
  }

  get activationDate(): moment.Moment {
    return this._activationDate;
  }

  set activationDate(value: moment.Moment) {
    this._activationDate = value;
  }

  get code(): string {
    return this._code;
  }

  set code(value: string) {
    this._code = value;
  }

  get contractValidation(): boolean {
    return this._contractValidation;
  }

  set contractValidation(value: boolean) {
    this._contractValidation = value;
  }

  get expectedContract(): boolean {
    return this._expectedContract;
  }

  set expectedContract(value: boolean) {
    this._expectedContract = value;
  }

  get extraNotes(): string {
    return this._extraNotes;
  }

  set extraNotes(value: string) {
    this._extraNotes = value;
  }

  get insertDate(): moment.Moment {
    return this._insertDate;
  }

  set insertDate(value: moment.Moment) {
    this._insertDate = value;
  }

  get measurementUnit(): MeasurementUnit {
    return this._measurementUnit;
  }

  set measurementUnit(value: MeasurementUnit) {
    this._measurementUnit = value;
  }

  get notes(): string {
    return this._notes;
  }

  set notes(value: string) {
    this._notes = value;
  }

  get quantity(): number {
    return this._quantity;
  }

  set quantity(value: number) {
    this._quantity = value;
  }

  get state(): ServiceState {
    return this._state;
  }

  set state(value: ServiceState) {
    this._state = value;
  }

  get subscription(): boolean {
    return this._subscription;
  }

  set subscription(value: boolean) {
    this._subscription = value;
  }
}
